<template>
    <b-card>

        <div class="row">
    <div class="col">
    <h5 class="card-title text-uppercase text-muted mb-0">Free copies earned</h5>
    <span class="h2 font-weight-bold mb-0">5</span>
    </div>
    <div class="col-auto">
    <div class="icon icon-shape pink text-white rounded-circle shadow">
    <i class="ni ni-books"></i>
    </div>
    </div>
    </div>
    <p class="mt-3 mb-0 text-sm">
    
    <span class="text-nowrap">Pre-Order result: 25</span>
    </p>


      
    </b-card>

</template>

<script>
import { mapGetters } from "vuex";
import moment from 'moment'

export default {
    name: "free-copies-widget",
    components: {
    },
    data() {
        return {
            loading: false,
            currentBook: [],
        };
    },
    props: {
        photoBookId: '',
        hasQrCode: false,
    },
    methods: {
        retrieveBook() {
            this.loading = true;
            this.$api.getPhotoBook(this.photoBookId)
                .then((response) => {
                    console.log(response);
                    this.currentBook = response.data;
                    console.log(this.currentBook);
                })
                .catch((e) => {
                    console.log(e);
                }).finally(() => {
                    this.loading = false
                });
        },
        formatDate(date) {
            return moment(date).format("Do MMM YYYY")
        },
        async copyURL(mytext) {
            try {
                
            await navigator.clipboard.writeText(mytext);
            alert('Copied');
            } catch($e) {
            alert('Cannot copy');
            alert($e);
            }
        }
    },
    computed: {
        ...mapGetters({ currentAccount: 'currentAccount' }),
        commentsLoaded: function () {
            return this.currentBook ? true : false;
        }
    },
    mounted() {
      //  this.retrieveBook();
    },
};
</script>
<style scoped>
.pinktext {
    color: #e62054;
}

.pink {
  background-color: #e62054;
}

</style>